export default "__VITE_ASSET__BsteIm25__"